<plotly-plot divId="plotCon" (initialized)="onInitialized()" [data]="data" [layout]="layout"> </plotly-plot>
